import { createFileRoute } from "@tanstack/react-router";

import { loadInPlace } from "../data/ensure.ts";
import { useViewer } from "../data/hooks.ts";
import { loadProjects } from "../projects/loaders.ts";
import { ProjectsPending } from "../projects/pending.tsx";
import { ProjectsPage } from "../projects/projects-page.tsx";
import { isSectionShown, sections } from "../shell/navigation.ts";
import { projectsSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !isSectionShown(sections.projects, viewer.role) ? (
    <NoAccessPage />
  ) : (
    <ProjectsPage viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/projects/")({
  staticData: { hasPropertyContext: true },
  validateSearch: projectsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context, location, cause }) =>
    loadInPlace(cause, async () => loadProjects(context.data, projectsSearch.parse(location.search))),
  pendingComponent: ProjectsPending,
  component: Page,
});
